import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'x-api-key': 'erp_Wa11paper_2026',
    'Content-Type': 'application/json'
  }
});

// Normalise all list responses to { value: [...] }
api.interceptors.response.use(response => {
  if (Array.isArray(response.data)) {
    response.data = { value: response.data };
  }
  return response;
});

export default api;